module.exports = __webpack_public_path__ + "static/media/banner-hello.a1c93b08.jpg";